import { __assign, __extends } from "tslib";
import { memoizeFunction, mergeStyleSets } from '@fluentui/react';
import React from 'react';
import { onRenderCommandBarButton } from '../Common/CoherenceHeaderHelpers';
import { GlobalSearch } from './GlobalSearch/GlobalSearch';
var SearchBoxOverlay = (function (_super) {
    __extends(SearchBoxOverlay, _super);
    function SearchBoxOverlay() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._searchBoxRef = React.createRef();
        _this._onSearch = function (value) {
            var _a = _this.props, dismissOnSearch = _a.dismissOnSearch, onClose = _a.onClose, searchBoxProps = _a.searchBoxProps;
            if (searchBoxProps && searchBoxProps.onSearch) {
                searchBoxProps.onSearch(value);
            }
            if (dismissOnSearch !== false) {
                onClose();
            }
        };
        _this._onChange = function (event, value) {
            var _a = _this.props, dismissOnSearch = _a.dismissOnSearch, onClose = _a.onClose, searchBoxProps = _a.searchBoxProps;
            if (searchBoxProps && searchBoxProps.onChange) {
                searchBoxProps.onChange(event, value);
            }
            if (dismissOnSearch !== false) {
                onClose();
            }
        };
        _this._onClear = function () {
            var _a = _this.props, dismissOnClear = _a.dismissOnClear, onClose = _a.onClose, searchBoxProps = _a.searchBoxProps;
            if (searchBoxProps && searchBoxProps.onClear) {
                searchBoxProps.onClear();
            }
            if (dismissOnClear !== false) {
                onClose();
            }
        };
        _this._onEscape = function () {
            var _a = _this.props, searchBoxProps = _a.searchBoxProps, onClose = _a.onClose;
            if (searchBoxProps && searchBoxProps.onEscape) {
                searchBoxProps.onEscape();
            }
            onClose();
        };
        _this._getStyles = function () {
            return getStylesInternal();
        };
        return _this;
    }
    SearchBoxOverlay.prototype.componentDidMount = function () {
        if (this._searchBoxRef.current) {
            this._searchBoxRef.current.focus();
        }
    };
    SearchBoxOverlay.prototype.render = function () {
        var _a = this.props, searchBoxProps = _a.searchBoxProps, onClose = _a.onClose;
        var Styles = this._getStyles();
        return (React.createElement("div", { className: Styles.root },
            React.createElement("div", { className: Styles.searchBoxRoot },
                React.createElement(GlobalSearch, __assign({}, searchBoxProps, { onSearch: this._onSearch, onChange: this._onChange, onClear: this._onClear, onEscape: this._onEscape, placeholder: searchBoxProps && searchBoxProps.placeholder ? searchBoxProps.placeholder : 'Search' }))),
            React.createElement("div", { className: Styles.closeButtonRoot }, onRenderCommandBarButton({
                key: 'CloseSearch',
                ariaLabel: 'Close search',
                iconOnly: true,
                iconProps: {
                    iconName: 'ChromeClose'
                },
                onClick: onClose
            }))));
    };
    return SearchBoxOverlay;
}(React.Component));
export { SearchBoxOverlay };
var buttonWidth = 48;
var getStylesInternal = memoizeFunction(function () {
    return mergeStyleSets({
        root: {
            width: '100%',
            display: 'grid',
            gridTemplateColumns: '1fr ' + buttonWidth + 'px',
            justifyContent: 'center'
        },
        searchBoxRoot: {
            marginLeft: '8px',
            alignSelf: 'center'
        },
        closeButtonRoot: {}
    });
});
//# sourceMappingURL=SearchBoxOverlay.js.map